//Search
export const TESTING_INSPECTOR_SEARCH_START_LOADING = "TESTING_INSPECTOR_SEARCH_START_LOADING";
export const TESTING_INSPECTOR_SEARCH_END_LOADING = "TESTING_INSPECTOR_SEARCH_END_LOADING";
export const TESTING_INSPECTOR_SEARCH_LOADED = "TESTING_INSPECTOR_SEARCH_LOADED";
export const SET_TESTING_INSPECTOR_FILTER = "SET_TESTING_INSPECTOR_FILTER";

//Edit
export const TESTING_INSPECTOR_START_LOADING = "TESTING_INSPECTOR_START_LOADING";
export const TESTING_INSPECTOR_END_LOADING = "TESTING_INSPECTOR_END_LOADING";
export const TESTING_INSPECTOR_LOADED = "TESTING_INSPECTOR_LOADED";
